import { Controller } from "stimulus"
import Utility from '../classes/Utility';

class CarouselPagination extends Controller {

  static targets = [
    'nextButton',
    'prevButton',
    'indicators',
    'indicator',
    'page',
    'first',
    'prev',
    'currentPage',
    'next',
    'last'
  ]

  static values = {
    totalItems: Number,
    perPage: Number
  }

  connect() {
    this.state = {
      currentItemIndex: 0,
      itemWidth: 0,
      totalItems: this.totalItemsValue,
      perPage: this.perPageValue,
    };

    EventManager.on('update-carousel-pagination-state', ({ width }) => {
      this.state.itemWidth = width;
    })

    this.updatePaginationUI();
  }

  updatePaginationUI() {
    this.__resetState();

    const totalPages = Math.ceil(parseInt(this.state.totalItems) / parseInt(this.perPageValue));
    const currentPage = (this.state.currentItemIndex + 1);

    this.prevButtonTarget.disabled = (currentPage === 1);
    this.nextButtonTarget.disabled = (currentPage === totalPages);

    this.__setPaginationPage(this.currentPageTarget, currentPage);
    this.__setPaginationPage(this.firstTarget, 1);
    this.__setPaginationPage(this.lastTarget, totalPages);

    if (totalPages < 4) {
      this.__hideTargets([this.firstTarget, this.prevTarget, this.nextTarget, this.lastTarget]);
      this.pageTargets.forEach((element, index) => {
        if (index < totalPages) {
          this.__setPaginationPage(element, index + 1);
        } else {
          element.classList.add('t-hidden');
        }
      });
    } else if (totalPages == 4) {
      this.__hideTargets([this.firstTarget, this.prevTarget, this.nextTarget]);
      this.pageTargets.forEach((element, index) => {
        this.__setPaginationPage(element, index + 1);
      });
    } else {
      if (currentPage < 4) {
        this.__hideTargets([this.firstTarget, this.prevTarget]);
        this.pageTargets.forEach((element, index) => {
          this.__setPaginationPage(element, index + 1);
        });
        this.nextTarget.setAttribute('data-pagination-page', 4);
      } else if (totalPages - currentPage < 3) {
        this.__hideTargets([this.prevTarget, this.nextTarget]);
        this.pageTargets.forEach((element, index) => {
          this.__setPaginationPage(element, totalPages - 2 + index);
        });
        this.prevTarget.setAttribute('data-pagination-page', totalPages - 3);
      } else {
        this.pageTargets.forEach((element, index) => {
          this.__setPaginationPage(element, currentPage - 1 + index);
        });
        this.prevTarget.setAttribute('data-pagination-page', currentPage - 2);
        this.nextTarget.setAttribute('data-pagination-page', currentPage + 2);
      }
    }
    this.__updateCurrentPageState();
  }

  handleNextItem() {
    this.state.currentItemIndex = Math.abs((this.state.currentItemIndex + 1) % this.state.totalItems);
    EventManager.emit('update-carousel-page', {
      width: this.state.itemWidth,
      idx: this.state.currentItemIndex,
      setHeight: true
    });
    this.updatePaginationUI();
  }

  handlePrevItem() {
    this.state.currentItemIndex = this.state.currentItemIndex === 0 ? this.state.totalItems - 1 : this.state.currentItemIndex - 1;
    EventManager.emit('update-carousel-page', {
      width: this.state.itemWidth,
      idx: this.state.currentItemIndex,
      setHeight: true
    });
    this.updatePaginationUI();
  }

  async select(e) {
    const currentPage = e.target.getAttribute('data-pagination-page');
    this.state.currentItemIndex = currentPage - 1;

    EventManager.emit('update-carousel-page', {
      width: this.state.itemWidth,
      idx: this.state.currentItemIndex,
      setHeight: true
    });
    this.updatePaginationUI();
  }

  __setPaginationPage(element, page) {
    element.setAttribute('data-pagination-page', page);
    element.textContent = page;
  }

  __hideTargets(items) {
    items.forEach(element => element.classList.add('t-hidden'));
  }

  __resetState() {
    this.firstTarget.classList.remove('t-hidden')
    this.prevTarget.classList.remove('t-hidden')
    this.nextTarget.classList.remove('t-hidden')
    this.lastTarget.classList.remove('t-hidden')
  }

  __updateCurrentPageState() {
    const currentPage = (this.state.currentItemIndex + 1);
    this.element.querySelectorAll('[data-pagination-page]').forEach(element => element.classList.remove('m-table-pagination-page-button__selected'))
    this.element.querySelector(`[data-pagination-page="${currentPage}"]:not(.t-hidden)`).classList.add('m-table-pagination-page-button__selected')
  }
}

export default CarouselPagination;
